import styles from 'partials/data-table/data-table.module.scss';

export const DataTableList = ({ children }) => {
	return <ul className={styles.list}>{children}</ul>;
};
